var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "global-product-combo",
      class: _vm.isFirst ? "global-product-combo--with-header" : "",
    },
    [
      _vm.isFirst
        ? _c(
            "div",
            {
              staticClass:
                "global-product-combo__header global-product-combo__set row no-gutters",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-xl-5 col-lg-12 header__part header__part--dst",
                },
                [
                  !_vm.omitDecorColum
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "global-product-combo__product-column global-product-combo__product-column--decor",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("global-product-combo.decor"))
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("global-product-combo.structure")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.omitProductColum
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "global-product-combo__product-column global-product-combo__product-column--material",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("global-product-combo.panel")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.omitRawboardColum
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "global-product-combo__product-column global-product-combo__product-column--material",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("global-product-combo.rawboard")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-xl-7 col-lg-12 header__part header__part--dimension",
                },
                [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 col-xl-8 part--dimension" },
                      [
                        !_vm.omitApplicationColumn
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "global-product-combo__product-column global-product-combo__product-column--application typo-light",
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "global-product-combo.recommended_application"
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "global-product-combo__product-column global-product-combo__product-column--dimensions typo-light",
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("global-product-combo.dimension")
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "global-product-combo__product-column global-product-combo__product-column--delivery-time typo-light",
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("global-product-combo.deliveryTime")
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticClass:
                            "global-product-combo__product-column global-product-combo__product-column--action",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6 col-xl-4 part--action" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "global-product-combo__product-column global-product-combo__product-column--action",
                          },
                          [_vm._t("actionHeader")],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "global-product-combo__set row no-gutters" }, [
        _c(
          "div",
          { staticClass: "col-xl-5 col-lg-12 set__part set__part--dst" },
          [
            !_vm.omitDecorColum
              ? _c(
                  "div",
                  {
                    staticClass:
                      "global-product-combo__product-column global-product-combo__product-column--decor",
                  },
                  [
                    _c("div", { staticClass: "product-column__label" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("global-product-combo.decor")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.product.title_d
                      ? [_vm._v("\n                     \n                ")]
                      : [
                          _c(
                            "a",
                            {
                              staticClass: "product-column__image",
                              attrs: { href: _vm.product.link_d },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  alt: _vm.composeAltText([
                                    _vm.product.title_d,
                                    _vm.product.titlesuffix_d,
                                    _vm.product.subtitle_d,
                                  ]),
                                  src: _vm.product.image_d_src,
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "product-column__details" },
                            [
                              _c("a", { attrs: { href: _vm.product.link_d } }, [
                                _c("span", [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.product.title_d)),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.product.titlesuffix_d)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.product.subtitle_d)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("a", { attrs: { href: _vm.product.link_s } }, [
                                _c("span", [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.product.title_s)),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.product.titlesuffix_s)
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.omitProductColum
              ? _c(
                  "div",
                  {
                    staticClass:
                      "global-product-combo__product-column global-product-combo__product-column--material",
                  },
                  [
                    _c("div", { staticClass: "product-column__label" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("global-product-combo.panel")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "product-column__image",
                        attrs: { href: _vm.product.link_t },
                      },
                      [
                        _c("img", {
                          attrs: {
                            alt: _vm.composeAltText([
                              _vm.product.title_t,
                              _vm.product.titlesuffix_t,
                              _vm.product.subtitle_t,
                            ]),
                            src: _vm.product.image_t_src,
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "product-column__details",
                        attrs: { href: _vm.product.link_t },
                      },
                      [
                        _c("span", [
                          _c("strong", [_vm._v(_vm._s(_vm.product.title_t))]),
                          _vm._v(" " + _vm._s(_vm.product.titlesuffix_t)),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.product.subtitle_t))]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.omitRawboardColum
              ? _c(
                  "div",
                  {
                    staticClass:
                      "global-product-combo__product-column global-product-combo__product-column--material",
                  },
                  [
                    _c("div", { staticClass: "product-column__label" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("global-product-combo.rawboard")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "product-column__image",
                        attrs: { href: _vm.product.link_r },
                      },
                      [
                        _c("img", {
                          attrs: {
                            alt: _vm.composeAltText([
                              _vm.product.title_r,
                              _vm.product.titlesuffix_r,
                              _vm.product.subtitle_r,
                            ]),
                            src: _vm.product.image_r_src,
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "product-column__details",
                        attrs: { href: _vm.product.link_r },
                      },
                      [
                        _c("span", [
                          _c("strong", [_vm._v(_vm._s(_vm.product.title_r))]),
                          _vm._v(" " + _vm._s(_vm.product.titlesuffix_r)),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.product.subtitle_r))]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xl-7 col-lg-12 set__part set__part--dimensions" },
          [
            _c("div", { staticClass: "row no-gutters" }, [
              _c("div", { staticClass: "col-md-6 col-xl-8 part--dimension" }, [
                !_vm.omitApplicationColumn
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "global-product-combo__product-column global-product-combo__product-column--application",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "small-responsive small-responsive--xs product-column__property",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "product-column__label typo-light hidden-xl",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "global-product-combo.recommended_application"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.product.recommended_application
                              ? _c("span", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "small-responsive small-responsive--xs",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.formatApplication(
                                              _vm.product
                                                .recommended_application
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "global-product-combo__product-column global-product-combo__product-column--dimensions",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "small-responsive small-responsive--xs product-column__property",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "product-column__label typo-light hidden-xl",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("global-product-combo.dimension"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.product.format) +
                              " x " +
                              _vm._s(_vm.product.height)
                          ),
                          _vm.product.kante ? _c("br") : _vm._e(),
                          _vm._v(_vm._s(_vm.product.kante)),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "global-product-combo__product-column global-product-combo__product-column--delivery-time",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "small-responsive small-responsive--xs product-column__property",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "product-column__label typo-light hidden-xl",
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t("global-product-combo.deliveryTime")
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "hidden-xl",
                          domProps: {
                            innerHTML: _vm._s(_vm.product.deliver_l),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "d-none d-xl-flex delivery-time--desktop",
                          },
                          [
                            _c("global-tooltip", [
                              _c("p", {
                                staticClass: "delivery-notice",
                                domProps: {
                                  innerHTML: _vm._s(_vm.product.deliver_l),
                                },
                              }),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 col-xl-4 part--action" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "global-product-combo__product-column global-product-combo__product-column--action",
                  },
                  [_vm._t("actionArea")],
                  2
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }